import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, ThemeProvider, createTheme, styled } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import DefaultInput from 'Components/Elements/Forms/DefaultInput'
import { useEffect } from 'react'
import JPNAutocompleteAddress from './JPNAutocompleteAddress'
let DialogWrapper = Dialog

const JPNModalSearch = observer(props => {
    const [open, setOpen] = useState(false)

    const [lastSearchText, setLastSearchText] = useState('')

    const [themeStyle] = useState(ModalSearchTheme)

    useEffect(() => {
        DialogWrapper = DefaultDialogWrapper
    }, [])

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden !important'
            document.getElementById('root').style.touchAction = 'none'
            document.getElementsByTagName('body')[0].style.touchAction = 'none'
        } else {
            document.body.style.overflow = ''
            document.getElementById('root').style.touchAction = ''
            document.getElementsByTagName('body')[0].style.touchAction = ''
        }
    }, [open])

    useEffect(() => {
        return () => {
            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                let body = document.getElementById('root')
                if (body) {
                    body.style.position = 'relative'
                }
            }
        }
    }, [])

    return (
        <ThemeProvider theme={themeStyle}>
            <Stack id="dialog-modal">
                <DefaultInput
                    type="zipSearch"
                    value={props.value}
                    label={props.label}
                    endAdornmentToggle={() => {
                        setOpen(true)
                    }}
                    onChange={props.onChange}
                />
                <DialogWrapper
                    disablePortal
                    open={open}
                    onClose={() => setOpen(false)}
                    scroll="paper"
                    TransitionProps={{
                        timeout: 300,
                        easing: {
                            enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
                            exit: 'cubic-bezier(0.4, 0, 0.6, 1)'
                        }
                    }}
                >
                    <DialogTitle>
                        <T>search_address</T>
                    </DialogTitle>

                    <DialogContent>

                        <JPNAutocompleteAddress
                            callbackAfterSelect={() => {
                                setOpen(false)
                            }}
                            lastSearchText={lastSearchText}
                            setLastSearchText={setLastSearchText}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Box width={'100%'} display={'flex'} justifyContent={'space-between'} mt='24px'>
                            <Button
                                onClick={() => setOpen(false)}
                                disableRipple
                                disableTouchRipple
                                disableFocusRipple
                                sx={{ textTransform: 'capitalize' }}
                                variant="text">
                                <T>back</T>
                            </Button>
                        </Box>
                    </DialogActions>
                </DialogWrapper>
            </Stack>
        </ThemeProvider>
    )
})

const DefaultDialogWrapper = styled(Dialog)(({ theme }) => {
    return {
        '.MuiDialog-paper': {
            '.MuiDialogTitle-root': {
                padding: '24px',
                color: '#33628C',
                lineHeight: '1',
                fontSize: '16px',
                fontWeight: '400',
                fontFamily: 'Poppins, NotoSansThai',
            }
        }
    }
})

const ModalSearchTheme = createTheme({
    typography: {
        option: {
            fontSize: '1.833333em',
            padding: '0.5em'
        }
    },
    components: {
        MuiDialog: {
            defaultProps: {
                PaperComponent: 'div'
            },
            styleOverrides: {
                paper: {
                    backgroundColor: '#f7f7f7',
                    width: '345px !important',
                    borderRadius: '12px',
                    margin: 0,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '0px 15px 20px 15px',
                    zIndex: '2'
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                    padding: '0 15px 20px 15px'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    with: '100% !important',
                    color: 'rgba(51, 98, 140, 1)',
                    fontSize: '16px',
                    fontFamily: 'Poppins, NotoSansThai',
                    fontWeight: '400',
                    '&:hover': {
                        backgroundColor: 'transparent'
                    },
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    position: 'absolute',
                    right: 15
                }
            }

        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    transition: 'opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }
            }
        },
    }
})

export default JPNModalSearch